var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t .black { fill: #171717; }\n\t ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "black",
    d: "M376.8837585,334.9065857c31.1039734-41.4648743,45.4220276-92.3013611,40.4436951-144.2441406 c-5.2761841-55.240387-31.7635193-105.1194992-74.5686951-140.4465485 C254.371994-22.7039795,123.1800461-10.1092119,50.2601662,78.2137222 C19.6242466,115.349144,2.7425768,162.3135834,2.7425768,210.4375153 c-0.0425501,55.4850616,21.5302448,107.66185,60.7399712,146.9141388 c39.1990852,39.2522583,91.3439789,60.8888855,146.8184052,60.931427c0.0638275,0,0.127655,0,0.1914673,0 c44.8475952,0,88.6526947-14.6584167,124.4584503-41.4648438l132.3727112,132.3939819l41.9328918-41.9329224 L376.8837585,334.9065857z M359.0766296,210.458786c0,81.9191742-66.6543884,148.5523224-148.5629272,148.5523224 c-81.9191895,0-148.5629578-66.6544189-148.5629578-148.5629578c0-81.9191742,66.6437607-148.5629425,148.5523071-148.5629425 C292.3371277,61.9703026,358.9702759,128.6247101,359.0766296,210.458786z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.559e446b.svg";
export { ForwardRef as ReactComponent };